//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            person: {},
            propertyName: '',
            move_in_date: moment().format("MM/DD/YYYY"),
            renewal_move_in_date: '',
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            units: [],
            unitId: null,
            unitName: null,
            unitSelected: '',
            today: moment().format('MM/DD/YYYY'),
            residentTransferValidations: [{ model: 'renewal_move_in_date', rules: 'required | date' }, { model: 'person.renewal_lease_expire_date', rules: 'required | after_or_equal:renewal_move_in_date' }, { model: 'person.renewal_rent_amount', rules: 'required | integer | min:1' }, { model: 'unitSelected', rules: 'required' }, { model: 'person.email', rules: 'required | email' }, { model: 'person.phone', rules: 'required | integer' }, { model: 'person.first_name', rules: 'required' }, { model: 'person.last_name', rules: 'required' }, { model: 'person.contact_preference', rules: 'required' }],
            contactPreferences: ['SMS', 'Email', 'Phone'],
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('resident-transfer-unit', function () {
            _this.refreshAvailableUnits();
            _this.residentTransferUnit();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('resident-transfer-unit');
    },

    methods: {
        residentTransferUnit: function residentTransferUnit() {
            var $el = this;
            $el.person = $el.resident;
            $el.propertyName = $el.resident.property.name;

            $el.renewal_move_in_date = '';
            $el.unitSelected = '';
            $el.person.renewal_lease_expire_date = '';
            $el.person.renewal_rent_amount = 0;
            $el.person.email = $el.person.person.email;
            $el.person.phone = $el.person.person.phone;
            $el.person.first_name = $el.person.person.first_name;
            $el.person.last_name = $el.person.person.last_name;
            $el.person.contact_preference = $el.person.person.contact_preference;
            if ($el.person.lease) {
                $el.renewal_move_in_date = moment().format("MM/DD/YYYY");
                $el.move_in_date = moment($el.person.lease.lease_start_date).format("MM/DD/YYYY");
                $el.person.renewal_lease_expire_date = moment($el.person.lease.lease_expiration_date).format("MM/DD/YYYY");
                $el.person.renewal_rent_amount = $el.person.lease.actual_rent_amount ? parseInt($el.person.lease.actual_rent_amount).toFixed(2) : 0;
            }

            $el.person.security_deposit = $el.person.person.security_deposit;
            this.$initValidator();
            $el.$children[0].$data.showSmallModal = true;
        },

        transferUnit: function transferUnit() {
            var _this2 = this;

            this.validator.setRules(this.residentTransferValidations).validate();
            if (this.validator.fails()) {
                return;
            }
            if (!this.units.filter(function (_ref) {
                var name = _ref.name;
                return name === _this2.unitSelected.name;
            })[0]) {
                this.$snotify.error("Error: Selected unit's Available Date conflicts with Transfer lease start date. Select new unit or lease start to continue.");
                return;
            }
            this.loading = true;
            var $el = this;

            var sendData = {
                residentId: $el.resident.id,
                unitName: $el.unitSelected.name,
                unitId: $el.unitSelected.id,
                nestio_unit_id: $el.unitSelected.nestio_unit_id,
                renewal_move_in_date: $el.renewal_move_in_date,
                renewal_lease_expire_date: $el.person.renewal_lease_expire_date,
                renewal_rent_amount: $el.person.renewal_rent_amount,
                email: $el.person.email,
                phone: $el.person.phone,
                security_deposit: $el.person.security_deposit,
                first_name: $el.person.first_name,
                last_name: $el.person.last_name,
                contact_preference: $el.person.contact_preference
            };

            window.axios.post('/prototype/person/resident/transfer-unit', sendData).then(function (response) {
                if (response.data.error) {
                    _this2.$snotify.error('Error transferring unit: ' + response.data.error);
                    _this2.loading = false;
                } else {
                    $el.$snotify.success('Resident transferred successfully.');
                    Event.$emit('refresh-resident-dashboard');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('close-resident-dashboard');
                    $el.refreshAvailableUnits();
                    _this2.closeModal();
                    _this2.loading = false;
                }
            });
        },
        refreshAvailableUnits: function refreshAvailableUnits() {
            var _this3 = this;

            var renewal_move_in = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            window.axios.get('/prototype/properties/nestio-available-units' + (renewal_move_in ? '?renewal_move_in=' + renewal_move_in : '')).then(function (response) {
                _this3.units = response.data.filter(function (unit) {
                    return unit.status != 'Pending Approval';
                });
            });
        },
        closeModal: function closeModal() {
            Event.$emit('close-small-modal');
        }
    },
    computed: {},
    watch: {
        unitSelected: function unitSelected() {
            var $el = this;
            $el.person.actual_rent_amount = $el.unitSelected.market_rent_amount;
        },
        renewal_move_in_date: function renewal_move_in_date() {
            this.refreshAvailableUnits(this.renewal_move_in_date);
            if (moment(this.person.lease.lease_expiration_date).isBefore(this.renewal_move_in_date)) {
                this.person.renewal_lease_expire_date = moment(this.renewal_move_in_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY");
            } else {
                this.person.renewal_lease_expire_date = moment(this.person.lease.lease_expiration_date).format("MM/DD/YYYY");
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentTransferUnit.vue
// module id = Pv5N
// module chunks = 0 1